module.exports = __webpack_public_path__ + "static/img/close_button.7c0192b9.png";